import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import jwtDecode from 'jwt-decode'
import selector from 'modules/Auth/selectors'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'
import corporateRequest from 'utils/corporateRequest'
import initializeApp from 'utils/initializeApp'
import { startPresenceHeartbeat, stopPresenceHeartbeat } from 'utils/presenceHeartbeat'
import request from 'utils/request'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'


export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const CORPORATE_ID = 'CORPORATE_ID'
export const CORPORATE_DATA = 'CORPORATE_DATA'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_COUNTRIES_LIST = 'SET_COUNTRIES_LIST'
export const SET_STATES_LIST = 'SET_STATES_LIST'
export const SET_CITIES_LIST = 'SET_CITIES_LIST'
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
export const SET_DASHBOARD_NAVS = 'SET_DASHBOARD_NAVS'
export const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'

export const SignInSuccess = token => {
  return {
    type: SIGN_IN_SUCCESS,
    token,
  }
}

export const setCorporateId = id => {
  return {
    type: CORPORATE_ID,
    id,
  }
}

export const setCorporateData = data => {
  return {
    type: CORPORATE_DATA,
    data,
  }
}

export const setUserRoleData = list => {
  return {
    type: SET_USER_ROLE,
    list,
  }
}

export const setUserId = id => {
  return {
    type: SET_USER_ID,
    id,
  }
}

export const setCurrentUserInfo = data => {
  return {
    type: SET_USER_INFO,
    data,
  }
}

export const setCurrentUserPermissions = data => {
  return {
    type: SET_USER_PERMISSIONS,
    data,
  }
}

export const setCountriesList = data => {
  return {
    type: SET_COUNTRIES_LIST,
    data,
  }
}

export const setStatesList = data => {
  return {
    type: SET_STATES_LIST,
    data,
  }
}

export const setCitiesList = data => {
  return {
    type: SET_CITIES_LIST,
    data,
  }
}

export const setDashboardData = data => {
  return {
    type: SET_DASHBOARD_DATA,
    data,
  }
}

export const setDashboardNavs = data => {
  return {
    type: SET_DASHBOARD_NAVS,
    data,
  }
}

export const setNotificationList = data => {
  return {
    type: SET_NOTIFICATION_LIST,
    data,
  }
}

export const SignIn = token => async dispatch => {
  try {
    if (token) {
      localStorage.clear()
      const decodedToken = jwtDecode(token)
      initializeApp(token) // pass the token to this function
      startPresenceHeartbeat()
      dispatch(SignInSuccess(token))
      dispatch(setCorporateId(decodedToken?.user?.corporate_id))
      dispatch(setUserId(decodedToken?.user?._id))
      return await dispatch(corporateDetails())
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}

export const corporateDetails = () => async (dispatch, getState) => {
  const state = getState()
  const corporateId = selector.getCorporateId(state)
  try {
    let response = await corporateRequest.get(`/corporates/${corporateId}`)
    dispatch(setCorporateData(response?.data?.data))
    return response?.data?.data
  } catch (error) {
    console.error('Getting error in corporate data', error)
  }
}

export const getUserRoles = () => async dispatch => {
  try {
    let response = await adminRequest.get(`/roles/journey/CORPORATE`)
    const roles = response?.data?.data?.filter(
      role => role.journey === 'CORPORATE'
    )
    dispatch(setUserRoleData(roles))
  } catch (error) {
    console.error('Getting error in corporate data', error)
  }
}

export const getUserInfo = () => async (dispatch, getState) => {
  const state = getState()
  const userId = selector.getUserId(state)
  try {
    let resp = await request.get(`user/${userId}`)
    let userData = resp?.data?.data
    if (userData?.pluginlive_id) {
      let adminResp = await adminRequest.get(`users/${userData?.pluginlive_id}`)
      if (adminResp?.status == 200 || adminResp?.status == 201) {
        userData.admin = adminResp?.data?.data
      }
    }
    dispatch(setCurrentUserInfo(userData))
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}

export const getUserPermissions = roleId => async dispatch => {
  try {
    let resp = await adminRequest.get(
      `roleEvents/${roleId}?journey=CORPORATE&roleName=ADMIN`
    )
    dispatch(setCurrentUserPermissions(resp?.data?.data))
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}

export const getListOfCountries =
  ({ searchValue, pageLimit = 50, currentPage = 0 }) =>
  async dispatch => {
    let searchKey = searchValue ? `search=${searchValue.trim()}` : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/countries?${searchKey}&currentPage=${currentPage}&pageLimit=${pageLimit}`
      )
      dispatch(setCountriesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of countries.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getListOfStates =
  ({ searchValue, pageLimit = 50, currentPage = 0, countryId }) =>
  async dispatch => {
    let searchKey = searchValue ? `search=${searchValue.trim()}` : ''
    let countryID = countryId ? `&countryId=${countryId}` : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/states?${searchKey}&currentPage=${currentPage}&pageLimit=${pageLimit}${countryID}`
      )
      dispatch(setStatesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of states.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getListOfCities =
  ({ searchValue, pageLimit = 50, currentPage = 0, countryId, stateId }) =>
  async dispatch => {
    let searchKey = searchValue ? `search=${searchValue.trim()}` : ''
    let countryID = countryId ? `&countryId=${countryId}` : ''
    let stateID = stateId ? `&stateId=${stateId}` : ''
    try {
      let response = await elasticSearchRequest.get(
        `/search/cities?${searchKey}&currentPage=${currentPage}&pageLimit=${pageLimit}${countryID}${stateID}`
      )
      dispatch(setCitiesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of citites.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const updateCorporateDetails = payload => async (dispatch, getState) => {
  const state = getState()
  const corporateId = selector.getCorporateId(state)
  try {
    let response = await corporateRequest.put(
      `/corporates/${corporateId}`,
      payload
    )

    function formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
    
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
    
      return [year, month, day].join('-');
    }

 
      let payloadData = {
        query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
      };

    elasticSearchSyncRequest.post(`/sync/corporate_list`,payloadData)
    dispatch(corporateDetails())
    return response
  } catch (error) {
    console.error('Getting error in updating corporate data', error)
    ErrorMessage(error?.response?.data?.message)
    return error
  }
}

export const corporateDashboardMatrix =
  ({ setLoading }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporateId = selector.getCorporateId(state)
    try {
      setLoading(true)
      let response = await corporateRequest.get(
        `/corporates/${corporateId}/dashboard/matrix`
      )
      dispatch(setDashboardData(response?.data?.data || {}))
      setLoading(false)
      return response
    } catch (error) {
      console.error('Getting error in corporate dashboard matrix', error)
      dispatch(setDashboardData({}))
      ErrorMessage(error?.response?.data?.message)
      setLoading(false)
      return error
    }
  }

export const signOut = () => async () => {
  try {
    stopPresenceHeartbeat()
    let response = await request.post(`users/signout`)
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Logged out successfully!')
      localStorage.clear()
      window.location.href = '/'
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}

export const checkout = email => async (dispatch, getState) => {
  try {
    const state = getState()
    const internalId = selector.getUserData(state)?.pluginlive_id
    let response = await request.post(`users/signout`)
    if (response?.status >= 200 && response?.status <= 300) {
      let journey = 'INTERNAL'
      let payLoad = {
        email,
        journey,
        journeyId: internalId,
      }
      try {
        const data = await request.post(`/user/portal/signin`, payLoad)

        if (data.status === 200) {
          localStorage.clear()
          SuccessMessage('Checkout out successfully!')

          let redirectLink =
            data?.data?.data?.redirectLink + '&landingPage=/corporates'
          window.location.href = redirectLink
        }
      } catch (error) {
        console.error('Getting error while checKout', error)
      }
    }
  } catch (error) {
    console.error('Getting error while logout', error)
  }
}

export const getNotificationsList =
  ({ userId, pageLimit = 20, currentPage = 1, isAction = false, setLoading }) =>
  async dispatch => {
    try {
      setLoading(true)
      let response = await request.get(
        `/users/${userId}/notification?pageLimit=${pageLimit}&currentPage=${currentPage}&isAction=${isAction}`
      )
      dispatch(setNotificationList(response?.data?.data || {})) // need to check after API available
      setLoading(false)
      return response
    } catch (error) {
      console.error('Getting error in user notification list =>', error)
      ErrorMessage(error?.response?.data?.message)
      setLoading(false)
      return error
    }
  }

export const markNotificationReadApi =
  ({ userId, payload }) =>
  async () => {
    try {
      let response = await request.put(
        `/users/${userId}/notification/markasread`,
        payload
      )
      return response
    } catch (error) {
      console.error('Getting error in marking notification as read.', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }
